export default "__VITE_ASSET__fB$6biw___"